import company from '../../constants/schema.org';
import { ldJson } from './ldJSON';

const CompanyMarkup = ({ url }) => ldJson(company(url));

export default CompanyMarkup;
